"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactEmptyState = _interopRequireDefault(require("@adsk/alloy-react-empty-state"));
var _useTranslations = require("../utils/i18n/useTranslations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IssuesEmptyState = () => {
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/_react.default.createElement(_alloyReactEmptyState.default, {
    illustrationType: _alloyReactEmptyState.default.ILLUSTRATION_TYPES.FOLDER_EMPTY_GREY,
    title: T.translate("referencePickerPlugin.noIssues"),
    description: T.translate("referencePickerPlugin.noIssuesDescription")
  });
};
var _default = exports.default = IssuesEmptyState;
//# sourceMappingURL=IssuesEmptyState.js.map